/**
 * Pure decision logic for the Buttons block's List-tab per-button Display
 * toggle switch. Extracted from ButtonsList's `handleToggleActive`
 * (behaviour-preserving — the `setTimeout` tooltip-hide side effect stays in
 * the component; only the WHICH-BRANCH + resulting list state moves here) so
 * the "at least 1 Button must be enabled" invariant is unit-testable without
 * React/DOM. Coverage-map cell: builder:6.23 (Buttons -> List: add/remove/
 * rename buttons; the per-button Display toggle + its guard).
 *
 * @param {Array<{id:*, isActive:boolean, tooltipVisible?:boolean}>} list
 * @param {*} id  the button being toggled
 * @returns {{blocked:boolean, list:Array}} blocked=true means the toggle was
 *   REFUSED (last active button) and the returned list only flips
 *   tooltipVisible on; blocked=false means isActive was flipped normally.
 */
export function resolveToggleActive(list, id) {
  const target = list.find((item) => item.id === id);
  if (!target) return { blocked: false, list };

  const activeItemsCount = list.filter((item) => item.isActive).length;

  if (target.isActive && activeItemsCount === 1) {
    // Refuse to deactivate the LAST active button — show the warning tooltip
    // instead of flipping isActive.
    return {
      blocked: true,
      list: list.map((item) =>
        item.id === id ? { ...item, tooltipVisible: true } : item
      ),
    };
  }

  return {
    blocked: false,
    list: list.map((item) =>
      item.id === id
        ? { ...item, isActive: !item.isActive, tooltipVisible: false }
        : item
    ),
  };
}
